"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ECDSA__factory", {
  enumerable: true,
  get: function get() {
    return _ECDSA__factory.ECDSA__factory;
  }
});
var _ECDSA__factory = require("./ECDSA__factory");